import { FunctionComponent } from 'react';
import TableBody from '@mui/material/TableBody';
import { Invoice } from 'src/types/invoice';
import InvoicesTableEmptyRow from './InvoicesTableEmptyRow';
import InvoicesTableDataRow from './InvoicesTableDataRow';

interface Props {
    invoices: Invoice[];
    loading: boolean;
}

const InvoicesTableBody: FunctionComponent<Props> = ({ invoices, loading }) => (
    <TableBody>
        {invoices.length === 0 && !loading ? (
            <InvoicesTableEmptyRow />
        ) : (
            invoices.map((invoice) => (
                <InvoicesTableDataRow key={invoice.id} invoice={invoice} />
            ))
        )}
    </TableBody>
);

export default InvoicesTableBody;
